import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { IObjectCustomFields } from 'src/app/features/settings/models/settings.models';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ObjectCustomFieldsFormComponent } from 'src/app/shared/components/object-custom-fields-form/object-custom-fields-form.component';

@Component({
  selector: 'app-catalog-custom-fields',
  templateUrl: './catalog-custom-fields.component.html',
  styleUrls: ['./catalog-custom-fields.component.scss']
})
export class CatalogCustomFieldsComponent {
  @ViewChild(ObjectCustomFieldsFormComponent) customFieldsForm?: ObjectCustomFieldsFormComponent;

  constructor(
    public dialogRef: MatDialogRef<CatalogCustomFieldsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { objectCustomFields: IObjectCustomFields },
  ) { }

  saveCustomFields(values: IObjectCustomFields['values']): void {
    this.dialogRef.close(values);
  }

  save(): void {
    this.customFieldsForm?.onSave();
  }

  cancel(): void {
    this.dialogRef.close();
  }

}
